import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlluserService } from 'src/app/admin/services/alluser/alluser.service';
import { CustomerService } from 'src/app/admin/services/customer/customer.service';

@Component({
    selector: 'app-customer-login-log',
    templateUrl: './customer-login-log.component.html',
    styleUrls: ['./customer-login-log.component.scss'],
    standalone: false
})
export class CustomerLoginLogComponent implements OnInit {

  constructor(
    private spinner: NgxSpinnerService,
    private router: ActivatedRoute,
    private customerService: CustomerService,
    private userService: AlluserService,
  ) { }

  data: any = '';
  temp: any = '';
  id: any = '';

  @ViewChild(DatatableComponent) myFilterTable: DatatableComponent | any;

  ngOnInit(): void {
    //this.id = this.router.snapshot.paramMap.get('id')
    this.router.parent?.params.subscribe(
      (params) => {
        this.id = params.data
      });
    this.getCustomerDataById()
  }

  getCustomerDataById() {
    this.spinner.show()
    this.customerService.getCustomerDataById({ _id: this.id }).subscribe(
      (res: any) => {
        this.spinner.hide()
        var userId = res.data.userId._id
        //console.log(userId)
        this.userService.getUserDataById({ _id: userId }).subscribe(
          (res: any) => {
            this.data = res.data.recent_logins.reverse()
            this.temp = this.data
            // console.log(this.data)
          }, err => {
            this.spinner.hide()
          }
        )
      },
      err => {
        this.spinner.hide()
        //console.log(err)
      }
    )
  }

  /**
 * Update filter
 */
  updateFilter(event: any) {
    const val = event.target.value.toLowerCase();

    const temp = this.temp.filter(function (d: any) {

      return d.cwalletId.toString().indexOf(val) !== -1 || !val
    });

    // update the rows
    this.data = temp;
    // Whenever the filter changes, always go back to the first page
    this.myFilterTable.offset = 0;
  }

}
